import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { MenuItem } from 'primeng/api';
import { TranslationService } from '../../shared';
import { TitleCasePipe } from '../../shared/pipes/titlecase.pipe';

@Component({
  selector: 'wl-dashboard-neo-financial-reports',
  templateUrl: 'dashboard-neo-financial-reports.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [TitleCasePipe],
    standalone: false
})
export class DashboardNeoFinancialReportsComponent implements OnInit {
  public menuItems: MenuItem[];

  public constructor(
    private _navigationService: NavigationService,
    private _translationService: TranslationService,
    private _titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit() {
    Promise.all([
      this._translationService.get('dashboard.revenue.reports.accounts-receivable'),
      this._translationService.get('dashboard.revenue.reports.revenue-by-type'),
      this._translationService.get('dashboard.revenue.reports.payments-applied'),
      this._translationService.get('dashboard.revenue.reports.revenue-recognition'),
    ]).then(([arSummary, revByType, pmtsApplied, revRecon]) => {
      this.menuItems = [
        {
          label: this._titleCasePipe.transform(arSummary),
          command: () => this.openARSummaryReport(),
        },
        {
          label: this._titleCasePipe.transform(revByType),
          command: () => this.openRevenueByTypeReport(),
        },
        {
          label: this._titleCasePipe.transform(pmtsApplied),
          command: () => this.openPaymentsAppliedReport(),
        },
        {
          label: this._titleCasePipe.transform(revRecon),
          command: () => this.openRevenueRecognitionReport(),
        },
      ];
    });
  }

  public openARSummaryReport() {
    this._navigationService.navigateToARSummaryReport();
  }

  public openRevenueByTypeReport() {
    this._navigationService.navigateToRevenueByTypeReport();
  }

  public openPaymentsAppliedReport() {
    this._navigationService.navigateToPaymentsAppliedReport();
  }
  public openRevenueRecognitionReport() {
    this._navigationService.navigateToRevenueRecognitionReport();
  }
}
